import { useState } from 'react'
import Button from '@mui/material/Button'
import SaveIcon from '@mui/icons-material/Save'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import { CreateGroupModal } from 'components/Participants/Group'
import { AdminUITheme } from 'types/AdminUiThemeMui'
import { useAppSelector } from 'redux/Hook'

const CreateGroupButton = () => {
  const [isModalVisible, setModalVisibility] = useState(false)
  const theme: AdminUITheme = useTheme()
  const { t } = useTranslation()

  const { selectedQuestions } = useAppSelector((state) => state.signUpQuestions)
  const { selectedFilters, hasFilterValueChanged } = useAppSelector(
    (state) => state.filterBuilder,
  )
  const { activeGroup } = useAppSelector((state) => state.participantGroups)

  const isGroupButtonDisabled = () => {
    // default group cannot be updated
    if (activeGroup && activeGroup.defaultSegment) return true

    // Disable button when a group is selected and enable it if a filter value has been changed
    if (activeGroup && !hasFilterValueChanged) return true

    const hasSignUpQuestionsSelected = selectedQuestions.length

    let hasAnyValueInFilter = false

    for (let i = 0; i < selectedFilters.length; i++) {
      if (selectedFilters[i].value) {
        hasAnyValueInFilter = true
        break
      }
    }

    const hasValue = hasAnyValueInFilter || hasSignUpQuestionsSelected

    return !hasValue
  }

  const isCreateGroupButtonDisabled = isGroupButtonDisabled()

  return (
    <>
      <Button
        id="filter-group"
        onClick={() => setModalVisibility(true)}
        size="large"
        data-testid="filter-group"
        disabled={isCreateGroupButtonDisabled}
        style={theme.ParticipantGrid.paddingTopPointFive}
        startIcon={<SaveIcon />}
      >
        {t('filters.participantGroup.label')}
      </Button>
      {!isCreateGroupButtonDisabled && (
        <CreateGroupModal
          isOpen={isModalVisible}
          setModalVisibility={setModalVisibility}
        />
      )}
    </>
  )
}

export default CreateGroupButton
